// Imports
import axios from 'axios';

// Export actions
/**
 * Apply the reviewed product code / quantity rows to Odoo.
 * @param {Object} { token: string, payload: { items: [{ product_code: string, quantity: number }] } }
 * @return {AxiosPromise} Http request
 */
export const createQuantityImport = ({ token, payload }) =>
  axios({
    method: 'post',
    url: `${window.API_URL}/quantityimport`,
    data: payload,
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });

/**
 * Resolve product codes to the products they match before anything is applied.
 * @param {Object} { token: string, payload: { codes: [string] } }
 * @return {AxiosPromise} Http request
 */
export const lookupQuantityImport = ({ token, payload }) =>
  axios({
    method: 'post',
    url: `${window.API_URL}/quantityimport/lookup`,
    data: payload,
    // Without this a failed validation is answered with a redirect and an empty
    // body instead of the JSON error, which reads back as a blank response.
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
